import angular from 'angular';
import {createRoute} from '../../core/config';

class SinglePostController {
  constructor($state, TrackingService) {
    this.$state = $state;
    this.trackingService = TrackingService;
  }

  $onInit() {
    this.trackingService.track('feed.post.singlepost', {postId: this.post.postId, subject: this.post.getTitle()});
  }

  onDelete(postId) {
    this.$state.go('app.neighborhood');
  }
}

angular.module('ll')
  .component('singlePost', {
    template: require('./singlepost.html'),
    controller: SinglePostController,
    controllerAs: 'vm',
    bindings: {
      post: '<'
    }
  })
  .config(createRoute({
    name: 'app.singlePost',
    component: 'singlePost',
    url: '/singlepost/:postId',
    resolve: {
      post: ($transition$, PostService, ToastMessageService, $state, $translate) => PostService.getPost($transition$.params().postId).then((post) => {
        return post;
      }, (err) => {
        ToastMessageService.showMessage($translate.instant('ERROR_MESSAGE.POST_NOT_ACCESSIBLE'));
        $state.go('app.neighborhood');
      })
    }
  }));
